import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Stable } from '@tcc-mono/vandijk/shared/data-access/models';
import { StableService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';

@Injectable({
  providedIn: 'root'
})
export class StableRepository extends CoreRepository<Stable> {

  public constructor(
    protected readonly _stableService: StableService
  ) {
    super(
      { name: 'stables' },
      _stableService
    )
  }
}
